export function ShareIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="32"
        width="32"
        height="32"
        rx="3"
        transform="rotate(90 32 0)"
        fill="#F4F4F4"
      />
      <g clipPath="url(#clip0_1872_5933)">
        <path
          d="M22 26C21.1667 26 20.4583 25.7083 19.875 25.125C19.2917 24.5417 19 23.8333 19 23C19 22.8833 19.0083 22.7623 19.025 22.637C19.0417 22.5117 19.0667 22.3993 19.1 22.3L12.05 18.2C11.7667 18.45 11.45 18.646 11.1 18.788C10.75 18.93 10.3833 19.0007 10 19C9.16667 19 8.45833 18.7083 7.875 18.125C7.29167 17.5417 7 16.8333 7 16C7 15.1667 7.29167 14.4583 7.875 13.875C8.45833 13.2917 9.16667 13 10 13C10.3833 13 10.75 13.071 11.1 13.213C11.45 13.355 11.7667 13.5507 12.05 13.8L19.1 9.7C19.0667 9.6 19.0417 9.48767 19.025 9.363C19.0083 9.23833 19 9.11733 19 9C19 8.16667 19.2917 7.45833 19.875 6.875C20.4583 6.29167 21.1667 6 22 6C22.8333 6 23.5417 6.29167 24.125 6.875C24.7083 7.45833 25 8.16667 25 9C25 9.83333 24.7083 10.5417 24.125 11.125C23.5417 11.7083 22.8333 12 22 12C21.6167 12 21.25 11.9293 20.9 11.788C20.55 11.6467 20.2333 11.4507 19.95 11.2L12.9 15.3C12.9333 15.4 12.9583 15.5127 12.975 15.638C12.9917 15.7633 13 15.884 13 16C13 16.1167 12.9917 16.2377 12.975 16.363C12.9583 16.4883 12.9333 16.6007 12.9 16.7L19.95 20.8C20.2333 20.55 20.55 20.3543 20.9 20.213C21.25 20.0717 21.6167 20.0007 22 20C22.8333 20 23.5417 20.2917 24.125 20.875C24.7083 21.4583 25 22.1667 25 23C25 23.8333 24.7083 24.5417 24.125 25.125C23.5417 25.7083 22.8333 26 22 26Z"
          fill="#3378B6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_5933">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 1 -1 0 26 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
